/* eslint-disable no-console */
/* eslint-disable react/no-unused-state */
/* eslint-disable */

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import JdAnimation from '../../animation/LoadingAnimation';
import FullPageView from '../../component/FullPageView';
import styles from './styles.module.scss';
import data from './data';
// import Instructions from '../../component/Instructions';
import FileUpload from '../../component/FileUpload1';
import Utility from '../../utils';
import Logger from '../../Logger';
import fileUploadstyles from '../../component/FileUpload1/styles.module.scss';
import JobDescriptionField from '../../component/JobDescriptionField1';
import Button from '../../component/Button';
import SaveJdPopup from '../../component/SaveJdPopup';
import config from '../../config';
import calculateScoreSteps from './scoreSteps';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { BASEPATH } from '../../lib/constants';


import {
    cacheRecentJDs,
    cacheReportData,
    updateUserId,
    updateUserName,
    updateUserFile,
    getResumeInHTML,
    updateResumeHtmlLink,
    updateResumeUrl,
    updateParsedResumeData
} from '../../store/actions/cache';
import unDrawImg from '../../assets/jdToResume/undraw_collecting.png';
import error3Img from '../../assets/LandingPage/error3.png';
import error2Img from '../../assets/jdToResume/error2.png';
import sampleReportImage from '../../assets/score/sampleReportImage.png';
import feature1 from '../../assets/score/feature1.png';
import feature2 from '../../assets/score/feature2.png';
import feature3 from '../../assets/score/feature3.png';
import buildResumeFlowImage from '../../assets/score/buildResumeFlow.png';

import Config from '../../config';
import Errorpopup from '../../component/ErrorPopup';
import Footer from '../../component/Footer/Footer';
import ConfirmPopup from '../../component/ConfirmPopup';
import JobDescriptionViewer from '../../component/JobDescriptionViewer';

import metaData from '../MetaData/data';

// TODO move all request to common request file
// TODO create new project with create-react-app and move the code there
//  TODO remove unused dependencies from package.json
// TODO configure eslint
const httpClient = axios.create();

httpClient.defaults.timeout = 85000;

const maxFileSize = 5242880;
const animationTime = 14300;

const saveJd = 'SAVE_JD_POPUP';

class resumeScore extends React.Component {
    PasteJdStepDiv;

    uploadResumeStepDiv;

    GetScoreStepDiv;

    stepText1Div;

    stepText2Div;

    stepText3Div;

    userBandwidth = 0;

    state = {
        isUploading: false,
        isUploaded: false,
        popupType: undefined,
        fullName: '',
        jobDescription: '',
        selectedJd: '',
        selectedSavedJd: '',
        isChecked: false,
        errorMessage: '',
        errorImage: error2Img,
        replaceJdName: '',
        isSample: false,
        isSampleSelected: false,
        isDone: false,
        isDriveUploadInProgress: false,
        currentStep: 1,
        stepsList: [1, 2, 3]
    };


    constructor(props) {
        super(props);
        console.log('this.props');
    }

    componentDidMount() {
        Utility.trackEvent('check-resume-score', 'PAGE_VISIT');
        this.testUserBandwidth();
        const {
            reduxProps: { cache },
            dispatchRecentJds,
            router
        } = this.props;
        console.log('reduxProps cache', cache);
        const { recentJds } = cache;
        // this.uploadResumeStepDiv = document.getElementById(uploadResumeStepID);
        // this.PasteJdStepDiv = document.getElementById(PasteJdStepId);
        // this.GetScoreStepDiv = document.getElementById(GetScoreStepId);
        // this.stepText1Div = document.getElementById('stepText0');
        // this.stepText2Div = document.getElementById('stepText1');
        // this.stepText3Div = document.getElementById('stepText2');
        // this.highlightInstruction('step1');
        if (recentJds && typeof recentJds[0] === 'string') {
            dispatchRecentJds([]);
        }

        const paymentStatus = localStorage.getItem('payment');
        if (paymentStatus === 'success') {
            this.setState({
                paymentPopup: false
            });
        } else {
            this.setState({
                paymentPopup: true
            });
        }
    }

    componentWillUnmount() {
        document.body.style.overflow = 'auto';
    }

    onSavedJdSelected = (jd, title) => {
        this.setState({
            jobDescription: jd,
            selectedSavedJd: title,
            isSampleSelected: false
        });
    };

    testUserBandwidth = async () => {
        Utility.speedTest(bandwidth => {
            this.userBandwidth = bandwidth;
        });
    };

    onChange = e => {
        const file = e.target.files[0];
        if (file) {
            const resume = file.name;
            const resumeType = resume.split('.');
            const UploadWrapDiv = document.getElementById('uploadResumeWithJdWrap');
            const uploadFileInput = document.getElementById('uploadResumeWithJd');


            if (this.validateResume(file.size, resumeType)) {
                this.setState({
                    isUploading: true,
                    fileName: resume,
                    resumeUploadError: ''
                });
                Utility.uploadFile(
                    file,
                    resumeType[resumeType.length - 1],
                    response => {
                        const {
                            dispatchUpdateHTMLLink,
                            dispatchUpdateResumeUrl,
                            dispatchUpdateParsedResume
                        } = this.props;
                        dispatchUpdateResumeUrl({
                            filename: resume,
                            url: response.data.s3DownloadLink
                        });

                        dispatchUpdateHTMLLink(response.data.s3HtmlLink);
                        setTimeout(() => {
                            this.getResumeInHTML(response.data.s3HtmlLink);
                        }, 15000);

                        dispatchUpdateParsedResume(response.data);

                        const { firstName, lastName, email, phoneNumber } = response.data;
                        this.highlightInstruction('step2');
                        UploadWrapDiv.classList.add(styles.onUploadInputField);
                        const fullName =
                            firstName && lastName
                                ? `${firstName} ${lastName}`
                                : firstName || lastName || '';
                        this.setState({
                            isUploaded: true,
                            fullName,
                            phoneNumber,
                            email,
                            resumeURL: response.data.s3DownloadLink
                        });
                        localStorage.setItem(
                            'resumeDetails',
                            JSON.stringify({
                                fileName: resume,
                                url: response.data.s3DownloadLink,
                                fullName: fullName,
                                phoneNumber: phoneNumber,
                                email: email
                            })
                        );
                        if (email) {
                            const requestBody = {
                                resumeUrl: response.data.s3DownloadLink,
                                OrgName: config.organisationName,
                                emailId: email
                            };
                            Utility.uploadResumeToSolar(requestBody);
                        }
                        Logger.postLogs(
                            `"resume-jd-relevance - resume parse successfull", ${JSON.stringify(
                                response.data
                            )}, resume file-size: ${(file.size / 1000000).toFixed(
                                2
                            )}mb, userBandwidth: ${this.userBandwidth}`
                        );
                    },
                    error => {
                        this.highlightInstruction('step1');
                        uploadFileInput.value = null;
                        this.setState({
                            popupType: 'error',
                            isUploading: false,
                            isUploaded: false,
                            fileName: '',
                            errorMessage:
                                'Error while uploading resume, please try again in a little while.',
                            errorImage: error2Img,
                            isDriveUploadInProgress: false
                        });
                        console.info('error', error.response);
                        Logger.postLogs(
                            `"resume-jd-relevance - resume parse Unsuccessfull", ${JSON.stringify(
                                error
                            )}, resume file-size: ${(file.size / 1000000).toFixed(
                                2
                            )}mb, userBandwidth: ${this.userBandwidth}`
                        );
                    }
                );
            }
        } else {
            this.setState({
                isUploading: false,
                isUploaded: false,
                isDriveUploadInProgress: false
            });
        }
    };

    getResumeInHTML = async S3HTMLLink => {
        const { dispatchGetResumeInHTML } = this.props;
        await Utility.getResumeInHtml(
            S3HTMLLink,
            res => {
                this.resumeInHtml = res.data;
                dispatchGetResumeInHTML(this.resumeInHtml);
            },
            error => {
                this.resumeInHtml = 'Error';
                console.info('error in resume viewer', error, error.response);
            }
        );
    };

    validateResume = (fileSize, resumeType) => {
        let isResumeValid;
        const supportedVersions = ['doc', 'docx', 'txt', 'rtf', 'pdf'];
        if (
            resumeType &&
            resumeType.length !== 0 &&
            supportedVersions.includes(resumeType[resumeType.length - 1])
        ) {
            if (fileSize <= maxFileSize) {
                isResumeValid = true;
            } else {
                isResumeValid = false;
                this.setState({
                    resumeUploadError: data.resumeSizeError,
                    isDriveUploadInProgress: false
                });
            }
        } else {
            isResumeValid = false;
            this.setState({
                resumeUploadError: data.invalidResumeFormat,
                isDriveUploadInProgress: false
            });
        }
        return isResumeValid;
    };

    resetUploadedFile = () => {
        document.getElementById('uploadResumeWithJd').value = null;
        document
            .getElementById('uploadResumeWithJdWrap')
            .classList.replace(
                styles.onUploadInputField,
                fileUploadstyles.uploadArea
            );
        this.highlightInstruction('step1');
        this.setState({
            isUploading: false,
            isUploaded: false,
            fullName: '',
            fileName: '',
            isDriveUploadInProgress: false
        });
    };

    onChangeText = text => {
        const { value } = text.currentTarget;
        this.setState({ jobDescription: value });
        if (value) {
            this.highlightInstruction('step3');
        } else {
            this.setState({ isSampleSelected: false, selectedJd: '' });
            this.highlightInstruction('step2');
        }
    };

    onJdSelected = (jd, title) => {
        this.setState({
            jobDescription: jd,
            selectedJd: title,
            selectedSavedJd: '',
            isSampleSelected: true
        });
        this.highlightInstruction('step3');
    };

    resetJobDescription = () => {
        this.setState({
            jobDescription: '',
            selectedJd: '',
            selectedSavedJd: '',
            isSampleSelected: false
        });
        this.highlightInstruction('step2');
    };

    onCheckboxClicked = () => {
        this.setState(prevState => ({ isChecked: !prevState.isChecked }));
    };

    onErrorRetry = () => {
        this.setState({ popupType: undefined });
    };

    // TODO remove elements referene and use props instead to highlight steps
    highlightInstruction = step => {
        switch (step) {
            case 'step2': {
                this.setState({ currentStep: 2 });
                break;
            }
            case 'step3': {
                this.setState({ currentStep: 3 });
                break;
            }
            case 1:
            default: {
                this.setState({ currentStep: 1 });
            }
        }
    };

    removeSavedJd = () => {
        this.setState({ selectedSavedJd: '' });
    };

    onChangeNameText = event => {
        this.setState({ fullName: event.target.value });
    };

    hydrateJobDescription = jdName => {
        const { jobDescription } = this.state;
        const { reduxProps, dispatchRecentJds } = this.props;
        const { cache } = reduxProps;
        const { recentJds } = cache;
        let tempJds = [];
        if (recentJds && recentJds.length !== 0) {
            tempJds = cache.recentJds;
            const jdsName = [];
            tempJds.forEach(jd => jdsName.push(jd.name));
            if (!jdsName.includes(jdName)) {
                if (tempJds && tempJds.length > 2) {
                    const recentThreeJDs = [];
                    const jdEntry = { name: jdName, description: jobDescription };
                    tempJds.push(jdEntry);
                    tempJds.reverse().forEach((jobDesc, index) => {
                        if (index <= 2) {
                            recentThreeJDs.push(jobDesc);
                        }
                    });
                    dispatchRecentJds(recentThreeJDs.reverse());
                    this.uploadJobDescription();
                } else {
                    const jdEntry = { name: jdName, description: jobDescription };
                    tempJds.push(jdEntry);
                    dispatchRecentJds(tempJds);
                    this.uploadJobDescription();
                }
            } else {
                this.setState({ popupType: 'confirmReplace', replaceJdName: jdName });
            }
        } else {
            const jdEntry = { name: jdName, description: jobDescription };
            tempJds.push(jdEntry);
            dispatchRecentJds(tempJds);
            this.uploadJobDescription();
        }
    };

    // TODO look for different approach to disable scroll instead of disabling scroll on body element
    renderPopup = () => {
        const {
            popupType,
            isChecked,
            replaceJdName,
            jobDescription,
            isSample,
            selectedSavedJd,
            selectedJd
        } = this.state;
        const {
            reduxProps: { cache },
            dispatchRecentJds,
            history,
            router
        } = this.props;
        if (popupType) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        switch (popupType) {
            case saveJd: {
                return isChecked ? (
                    <div className={styles.popupStyle}>
                        <SaveJdPopup
                            title={data.saveJdPopupTitle}
                            label={data.saveJdInputLabel}
                            onCancel={() => this.setState({ popupType: undefined })}
                            onSave={jdName => this.hydrateJobDescription(jdName)}
                        />
                    </div>
                ) : null;
            }
            case 'error': {
                const { errorMessage, errorImage } = this.state;
                return (
                    <Errorpopup
                        history={history}
                        onErrorRetry={this.onErrorRetry}
                        errorImage={errorImage}
                        errorMessage={errorMessage}
                    />
                );
            }
            case 'animation': {
                const { isDone } = this.state;
                return (
                    <FullPageView history={history} style={styles.animationFullPage}>
                        <JdAnimation
                            isDone={isSample || isDone}
                            onAnimationEnd={() => {
                                if (isSample) {
                                    router.navigate('/report', {
                                        state: {
                                            data: data.trySampleResponse,
                                            isSample
                                        }
                                    });
                                }
                            }}
                        />
                    </FullPageView>
                );
            }
            case 'confirmReplace': {
                return (
                    <div className={styles.popupStyle}>
                        <ConfirmPopup
                            title="Job description already exist with this name, do you want to replace ?"
                            onOk={() => {
                                const { recentJds } = cache;
                                let tempJds = [];

                                tempJds = recentJds.map(jd => {
                                    if (jd.name === replaceJdName) {
                                        // eslint-disable-next-line no-param-reassign
                                        jd.description = jobDescription;
                                    }
                                    return jd;
                                });
                                dispatchRecentJds(tempJds);
                                this.uploadJobDescription();
                            }}
                            onCancel={() => this.setState({ popupType: saveJd })}
                        />
                    </div>
                );
            }
            case 'jdViewer': {
                return (
                    <div className={styles.popupStyle}>
                        <JobDescriptionViewer
                            jdTitle={selectedSavedJd || selectedJd}
                            value={jobDescription}
                            onchangeJD={this.onChangeText}
                            onBack={() => this.setState({ popupType: undefined })}
                            onMeasureClick={this.onMeasureClick}
                        />
                    </div>
                );
            }
            default:
                return null;
        }
    };

    onMeasureClick = () => {
        const { isChecked, selectedSavedJd } = this.state;
        if (isChecked && !selectedSavedJd) {
            this.setState({ popupType: saveJd });
        } else {
            this.uploadJobDescription();
        }
    };

    uploadJobDescription = () => {
        const { jobDescription } = this.state;
        this.setState({ popupType: 'animation' });
        // eslint-disable-next-line no-undef
        const file = new File([jobDescription], 'jobDescription.txt', {
            type: 'text/plain'
        });
        Utility.uploadFile(
            file,
            'txt',
            response => {
                this.setState({ jobDescriptionURL: response.data.s3DownloadLink });
                Logger.postLogs(
                    `"resume-jd-relevance - job description upload successfull", ${JSON.stringify(
                        response.data
                    )}`
                );
                this.checkRelevance();
            },
            error => {
                this.setState({
                    popupType: 'error',
                    errorMessage:
                        'Error while uploading job description, please try again in a little while.',
                    gotoSection: 'secondSection',
                    errorImage: error3Img
                });
                Logger.postLogs(
                    `"resume-jd-relevance - job description upload Unsuccessfull", ${JSON.stringify(
                        error
                    )}`
                );
            }
        );
    };

    checkRelevance = async () => {
        const {
            resumeURL,
            jobDescriptionURL,
            fullName,
            phoneNumber,
            email,
            selectedJd,
            isSampleSelected
        } = this.state;
        const {
            dispatchReportData,
            dispatchUpdateUserId,
            dispatchUpdateUserName,
            dispatchUpdateUserFile,
            dispatchGetResumeInHTML,
            history,
            router
        } = this.props;
        const url = config.releavanceCheck;
        const configObj = {
            headers: {
                'content-type': 'application/json',
                Accept: '/'
            }
        };
        const requestBody = {
            Resume_URL: resumeURL,
            Jd_URL: jobDescriptionURL,
            Full_name: fullName,
            Email: email,
            Phone_number: phoneNumber,
            is_sample_jd: isSampleSelected,
            jd_title: selectedJd || 'None',
            application: 'panna_score_api',
            skills_deleted_status: 0
        };
        const start = new Date().getTime();
        httpClient
            .post(url, requestBody, configObj)
            .then(async response => {
                if (response.data.status_code === 0) {
                    Logger.postLogs(
                        `"resume-jd-relevance - relevance check unsuccessfull", ${response.data.status_msg}`
                    );
                    this.setState({
                        popupType: 'error',
                        errorMessage: response.data.status_msg,
                        errorImage: unDrawImg
                    });
                } else {
                    const { Uid } = response.data;

                    // FIXME: Add back later
                    // const res = await httpClient.post(
                    //   'https://resume-builder-ai.mroads.com/improved_res',
                    //   {
                    //     Resume_URL: resumeURL,
                    //     Jd_URL: jobDescriptionURL
                    //   }
                    // );

                    // const aiResumeData = res.data;
                    const aiResumeData = null;
                    let navigationTime = 0;
                    let date = new Date().getTime();
                    date = new Date().getTime() - start;
                    console.info('response time: ', `${date} ms`);
                    this.reportData = response.data;
                    navigationTime = animationTime > date ? animationTime - date : 4000;
                    console.info('response time: ', `${date} ms`);
                    this.setState({ isDone: true });
                    setTimeout(
                        () =>
                            // history.push({
                            //   pathname: '/report',
                            //   data: this.reportData,
                            //   resumeInHtml: this.resumeInHtml
                            // }),
                            router.navigate('/report', {
                                state: {
                                    resumeInHtml: this.resumeInHtml,
                                    data: this.reportData,
                                    aiResumeData: aiResumeData
                                }
                            }),
                        navigationTime
                    );
                    Logger.postLogs(
                        `"resume-jd-relevance - relevance check successfull", ${JSON.stringify(
                            response.data
                        )}`
                    );
                    dispatchUpdateUserFile({
                        resume: resumeURL,
                        jd: jobDescriptionURL
                    });
                    dispatchUpdateUserId(Uid);
                    dispatchUpdateUserName(fullName);
                    dispatchReportData(this.reportData);
                    dispatchGetResumeInHTML(this.resumeInHtml);
                }
            })
            .catch(error => {
                // eslint-disable-next-line
                console.info('error in DS service', error);
                Logger.postLogs(
                    `"resume-jd-relevance - relevance check unsuccessfull", ${JSON.stringify(
                        error
                    )}`
                );
                this.setState({
                    popupType: 'error',
                    errorMessage:
                        'There was an error while collecting your data. Please try again',
                    errorImage: unDrawImg
                });
            });
    };

    checkSampleRelevance = () => {
        try {
            Utility.trackEvent('check-resume-score', 'BUTTON_CLICK', 'Try Sample');
        } catch (error) {
            console.error('Failed to track event:', error);
        }
        this.setState({ popupType: 'animation', isSample: true });
    };

    onDriveUploadError = error => {
        this.setState({ resumeUploadError: error, isDriveUploadInProgress: false });
    };

    driveUploadingInProgress = inProgress => {
        this.setState({
            isDriveUploadInProgress: inProgress,
            resumeUploadError: ''
        });
    };

    render() {
        const {
            isUploading,
            isUploaded,
            fileName,
            fullName,
            jobDescription,
            selectedJd,
            selectedSavedJd,
            resumeUploadError,
            isChecked,
            isDriveUploadInProgress,
            currentStep
        } = this.state;
        const {
            reduxProps: { cache },
            history,
            router
        } = this.props;

        return (
            <div className={styles.overLay}>
                <FullPageView
                    style={[currentStep !== 1 ? styles.height100 : ''].join(' ')}
                    history={history}
                >
                    <Helmet>
                        <title>{metaData.scoreHomePage.title}</title>
                        <link rel="canonical" href="https://www.panna.ai/score" />
                        <meta name='title' content={metaData.scoreHomePage.metaTitle} />
                        <meta name='description' content={metaData.scoreHomePage.metaDescription} />
                    </Helmet>

                    {/* {this.state.paymentPopup && <PaymentModal />} */}
                    <div className={styles.container}>
                        {this.renderPopup()}
                        <div className={styles.headerContainer}>
                            <div className={styles.headerSection}>
                                <div className={[styles.left, currentStep !== 1 ? styles.width100 : ''].join(' ')}>
                                    <h1 className={styles.headText}>
                                        AI resume scorer - Get resume relevance score for <span className={styles.freeText}>FREE!</span>
                                    </h1>
                                    <div className={styles.content}>
                                        Boost your job search with our industry leading AI scorer, meticulously engineered to deliver a resume that ranks high in ATS screenings. Rank your resume against any job description.
                                    </div>
                                    <div className={[styles.fileUploadContainer, currentStep !== 1 ? styles.opacity1 : ''].join(' ')}>
                                        <Instructions currentStep={currentStep} />
                                        <FileUpload
                                            fileName={fileName}
                                            fullName={fullName}
                                            onChange={this.onChange}
                                            resetUploadedFile={this.resetUploadedFile}
                                            isUploading={isUploading}
                                            isUploaded={isUploaded}
                                            errorMessage={resumeUploadError}
                                            onChangeNameText={this.onChangeNameText}
                                            testSpeed={this.testUserBandwidth}
                                            isUploadingInProgress={isDriveUploadInProgress}
                                        />
                                        {/* TODO instead of ternary use popup tyep to render job description field */}
                                        {isUploaded ? (
                                            <JobDescriptionField
                                                jobDescription={jobDescription}
                                                onChange={this.onChangeText}
                                                onJdSelected={this.onJdSelected}
                                                onSavedJdSelected={this.onSavedJdSelected}
                                                selectedJd={selectedJd}
                                                selectedSavedJd={selectedSavedJd}
                                                resetJd={this.resetJobDescription}
                                                isChecked={isChecked}
                                                onCheckboxClicked={this.onCheckboxClicked}
                                                onMeasureClick={this.onMeasureClick}
                                                recentJds={cache.recentJds}
                                                onRemoveSavedJd={this.removeSavedJd}
                                                openJDViewer={() => this.setState({ popupType: 'jdViewer' })}
                                            />
                                        ) : (
                                            null
                                        )}
                                    </div>
                                    {!isUploaded ? <div className={styles.trySampleWrap}>
                                        <div className={styles.sampleWrap}>
                                            <div className={styles.sampleLable}>
                                                or want to know how it works ?
                                            </div>
                                            <Button
                                                id="try-sample"
                                                text="Try sample"
                                                buttonStyle={styles.trySample}
                                                onClick={this.checkSampleRelevance}
                                                disable={
                                                    isUploaded || isUploading || isDriveUploadInProgress
                                                }
                                            />
                                        </div>
                                    </div> : null}
                                </div>
                                <div className={styles.right}>

                                </div>

                            </div>

                        </div>
                    </div>

                </FullPageView >
                <div>
                    <BlackStrip />
                    <ReportDisplay />
                    <FeaturesStrip />
                    <CalculateScore />
                    <BuildResume />
                </div>

                <div className={styles.footer}>
                    <Footer />
                </div>
            </div>
        );
    }
}

const Instructions = ({ currentStep }) => {
    console.log('currentStep:', currentStep);
    return <div className={styles.instructionsContainer}>

        <div className={[styles.step, currentStep === 1 ? styles.activeInstruction : ''].join(' ')}>UPLOAD RESUME
            <div className={styles.circle}></div>
            <svg xmlns="http://www.w3.org/2000/svg" width="150" height="8" viewBox="0 0 131 8" fill="none">
                <path d="M130.354 4.35356C130.549 4.1583 130.549 3.84172 130.354 3.64646L127.172 0.464477C126.976 0.269215 126.66 0.269215 126.464 0.464477C126.269 0.659739 126.269 0.976322 126.464 1.17158L129.293 4.00001L126.464 6.82844C126.269 7.0237 126.269 7.34028 126.464 7.53554C126.66 7.73081 126.976 7.73081 127.172 7.53555L130.354 4.35356ZM-4.37114e-08 4.5L0.984849 4.5L0.984849 3.5L4.37114e-08 3.5L-4.37114e-08 4.5ZM2.95455 4.5L4.92424 4.5L4.92424 3.5L2.95455 3.5L2.95455 4.5ZM6.89394 4.5L8.86364 4.5L8.86364 3.5L6.89394 3.5L6.89394 4.5ZM10.8333 4.5L12.803 4.5L12.803 3.5L10.8333 3.5L10.8333 4.5ZM14.7727 4.5L16.7424 4.5L16.7424 3.5L14.7727 3.5L14.7727 4.5ZM18.7121 4.5L20.6818 4.5L20.6818 3.5L18.7121 3.5L18.7121 4.5ZM22.6515 4.5L24.6212 4.5L24.6212 3.5L22.6515 3.5L22.6515 4.5ZM26.5909 4.5L28.5606 4.5L28.5606 3.5L26.5909 3.5L26.5909 4.5ZM30.5303 4.5L32.5 4.5L32.5 3.5L30.5303 3.5L30.5303 4.5ZM34.4697 4.5L36.4394 4.5L36.4394 3.5L34.4697 3.5L34.4697 4.5ZM38.4091 4.5L40.3788 4.5L40.3788 3.5L38.4091 3.5L38.4091 4.5ZM42.3485 4.5L44.3182 4.5L44.3182 3.5L42.3485 3.5L42.3485 4.5ZM46.2879 4.5L48.2576 4.5L48.2576 3.5L46.2879 3.5L46.2879 4.5ZM50.2273 4.5L52.197 4.5L52.197 3.5L50.2273 3.5L50.2273 4.5ZM54.1667 4.5L56.1363 4.5L56.1363 3.5L54.1667 3.5L54.1667 4.5ZM58.106 4.50001L60.0757 4.50001L60.0757 3.50001L58.106 3.50001L58.106 4.50001ZM62.0454 4.50001L64.0151 4.50001L64.0151 3.50001L62.0454 3.50001L62.0454 4.50001ZM65.9848 4.50001L67.9545 4.50001L67.9545 3.50001L65.9848 3.50001L65.9848 4.50001ZM69.9242 4.50001L71.8939 4.50001L71.8939 3.50001L69.9242 3.50001L69.9242 4.50001ZM73.8636 4.50001L75.8333 4.50001L75.8333 3.50001L73.8636 3.50001L73.8636 4.50001ZM77.803 4.50001L79.7727 4.50001L79.7727 3.50001L77.803 3.50001L77.803 4.50001ZM81.7424 4.50001L83.7121 4.50001L83.7121 3.50001L81.7424 3.50001L81.7424 4.50001ZM85.6818 4.50001L87.6515 4.50001L87.6515 3.50001L85.6818 3.50001L85.6818 4.50001ZM89.6212 4.50001L91.5909 4.50001L91.5909 3.50001L89.6212 3.50001L89.6212 4.50001ZM93.5606 4.50001L95.5303 4.50001L95.5303 3.50001L93.5606 3.50001L93.5606 4.50001ZM97.5 4.50001L99.4697 4.50001L99.4697 3.50001L97.5 3.50001L97.5 4.50001ZM101.439 4.50001L103.409 4.50001L103.409 3.50001L101.439 3.50001L101.439 4.50001ZM105.379 4.50001L107.348 4.50001L107.348 3.50001L105.379 3.50001L105.379 4.50001ZM109.318 4.50001L111.288 4.50001L111.288 3.50001L109.318 3.50001L109.318 4.50001ZM113.258 4.50001L115.227 4.50001L115.227 3.50001L113.258 3.50001L113.258 4.50001ZM117.197 4.50001L119.167 4.50001L119.167 3.50001L117.197 3.50001L117.197 4.50001ZM121.136 4.50001L123.106 4.50001L123.106 3.50001L121.136 3.50001L121.136 4.50001ZM125.076 4.50001L127.045 4.50001L127.045 3.50001L125.076 3.50001L125.076 4.50001ZM129.015 4.50001L130 4.50001L130 3.50001L129.015 3.50001L129.015 4.50001Z" fill="black" fill-opacity="0.2" />
            </svg>
        </div>

        <div className={[styles.step, currentStep === 2 ? styles.activeInstruction : ''].join(' ')}>JOB DESCRIPTION  <div className={styles.circle}></div>
            <svg xmlns="http://www.w3.org/2000/svg" width="150" height="8" viewBox="0 0 131 8" fill="none">
                <path d="M130.354 4.35356C130.549 4.1583 130.549 3.84172 130.354 3.64646L127.172 0.464477C126.976 0.269215 126.66 0.269215 126.464 0.464477C126.269 0.659739 126.269 0.976322 126.464 1.17158L129.293 4.00001L126.464 6.82844C126.269 7.0237 126.269 7.34028 126.464 7.53554C126.66 7.73081 126.976 7.73081 127.172 7.53555L130.354 4.35356ZM-4.37114e-08 4.5L0.984849 4.5L0.984849 3.5L4.37114e-08 3.5L-4.37114e-08 4.5ZM2.95455 4.5L4.92424 4.5L4.92424 3.5L2.95455 3.5L2.95455 4.5ZM6.89394 4.5L8.86364 4.5L8.86364 3.5L6.89394 3.5L6.89394 4.5ZM10.8333 4.5L12.803 4.5L12.803 3.5L10.8333 3.5L10.8333 4.5ZM14.7727 4.5L16.7424 4.5L16.7424 3.5L14.7727 3.5L14.7727 4.5ZM18.7121 4.5L20.6818 4.5L20.6818 3.5L18.7121 3.5L18.7121 4.5ZM22.6515 4.5L24.6212 4.5L24.6212 3.5L22.6515 3.5L22.6515 4.5ZM26.5909 4.5L28.5606 4.5L28.5606 3.5L26.5909 3.5L26.5909 4.5ZM30.5303 4.5L32.5 4.5L32.5 3.5L30.5303 3.5L30.5303 4.5ZM34.4697 4.5L36.4394 4.5L36.4394 3.5L34.4697 3.5L34.4697 4.5ZM38.4091 4.5L40.3788 4.5L40.3788 3.5L38.4091 3.5L38.4091 4.5ZM42.3485 4.5L44.3182 4.5L44.3182 3.5L42.3485 3.5L42.3485 4.5ZM46.2879 4.5L48.2576 4.5L48.2576 3.5L46.2879 3.5L46.2879 4.5ZM50.2273 4.5L52.197 4.5L52.197 3.5L50.2273 3.5L50.2273 4.5ZM54.1667 4.5L56.1363 4.5L56.1363 3.5L54.1667 3.5L54.1667 4.5ZM58.106 4.50001L60.0757 4.50001L60.0757 3.50001L58.106 3.50001L58.106 4.50001ZM62.0454 4.50001L64.0151 4.50001L64.0151 3.50001L62.0454 3.50001L62.0454 4.50001ZM65.9848 4.50001L67.9545 4.50001L67.9545 3.50001L65.9848 3.50001L65.9848 4.50001ZM69.9242 4.50001L71.8939 4.50001L71.8939 3.50001L69.9242 3.50001L69.9242 4.50001ZM73.8636 4.50001L75.8333 4.50001L75.8333 3.50001L73.8636 3.50001L73.8636 4.50001ZM77.803 4.50001L79.7727 4.50001L79.7727 3.50001L77.803 3.50001L77.803 4.50001ZM81.7424 4.50001L83.7121 4.50001L83.7121 3.50001L81.7424 3.50001L81.7424 4.50001ZM85.6818 4.50001L87.6515 4.50001L87.6515 3.50001L85.6818 3.50001L85.6818 4.50001ZM89.6212 4.50001L91.5909 4.50001L91.5909 3.50001L89.6212 3.50001L89.6212 4.50001ZM93.5606 4.50001L95.5303 4.50001L95.5303 3.50001L93.5606 3.50001L93.5606 4.50001ZM97.5 4.50001L99.4697 4.50001L99.4697 3.50001L97.5 3.50001L97.5 4.50001ZM101.439 4.50001L103.409 4.50001L103.409 3.50001L101.439 3.50001L101.439 4.50001ZM105.379 4.50001L107.348 4.50001L107.348 3.50001L105.379 3.50001L105.379 4.50001ZM109.318 4.50001L111.288 4.50001L111.288 3.50001L109.318 3.50001L109.318 4.50001ZM113.258 4.50001L115.227 4.50001L115.227 3.50001L113.258 3.50001L113.258 4.50001ZM117.197 4.50001L119.167 4.50001L119.167 3.50001L117.197 3.50001L117.197 4.50001ZM121.136 4.50001L123.106 4.50001L123.106 3.50001L121.136 3.50001L121.136 4.50001ZM125.076 4.50001L127.045 4.50001L127.045 3.50001L125.076 3.50001L125.076 4.50001ZM129.015 4.50001L130 4.50001L130 3.50001L129.015 3.50001L129.015 4.50001Z" fill="black" fill-opacity="0.2" />
            </svg></div>
        <div className={[styles.step, currentStep === 3 ? styles.activeInstruction : ''].join(' ')}>GET YOUR SCORE <div className={styles.circle}></div></div>
    </div>
}

const BlackStrip = () => {
    return <div className={styles.blackStripContainer}>
        <div className={styles.blackStripContainerChild}>
            <div className={[styles.part1]}>
                <span className={styles.bigFont}>1M+</span><br />  resumes already scored
            </div>
            <div className={[styles.part1, styles.rightBorder].join(' ')}>
                <span className={styles.bigFont}> 90%</span><br />
                users improved their resume scores
            </div>
            <div className={[styles.part1, styles.rightBorder].join(' ')}>
                <span className={styles.bigFont}>  #1 </span><br />
                ranked by leading HR experts
            </div>
        </div>
    </div>
}

const ReportDisplay = () => {
    return <div className={styles.reportDisplayContainer}>
        <div className={styles.content}>
            Use our FREE AI-powered platform to tailor your resume for a specific job role and make yourself stand out from the competition!
            <br /><br />
            Our AI Resume Score application helps you elevate your resume. Our advanced AI algorithms will analyze your resume, providing analysis and insights. Discover how well your resume matches job requirements with personalized feedback on skills, action verbs, and improvements. Don’t leave your career to chance—find out if your resume is good enough today!
        </div>
        <div className={styles.image}>
            <img src={sampleReportImage} className={styles.sampleReportImage} lt='image' />
        </div>
    </div>
}

const FeaturesStrip = () => {
    return <div className={styles.featuresMainContainer}>
        <div className={styles.heading}>Features</div>
        <div className={styles.featuresContainer}>
            <div className={styles.feature}>
                <img className={styles.featureIcon} src={feature1} />
                <div className={styles.featureHeading}>Resume Analysis</div>
                <div className={styles.featureContent}>Get noticed by recruiters and surpass the application tracking system (ATS) using our job-specific feedback. Revolutionary analysis of multiple jobs with an unlimited number of scans</div>
            </div>
            <div className={styles.feature}>
                <img className={styles.featureIcon} src={feature2} />
                <div className={styles.featureHeading}>Smart skill scoring</div>
                <div className={styles.featureContent}>We use machine learning algorithms to quickly select top skills, keywords, and buzzwords from job postings in order to compare them to what is listed on your resume.</div>
            </div>
            <div className={styles.feature}>
                <img className={styles.featureIcon} src={feature3} />
                <div className={styles.featureHeading}>Resume relevance score</div>
                <div className={styles.featureContent}>The Relevance Score goes beyond skill match and uses complex algorithms to evaluate the context of experience, skills, keywords, educational qualifications, etc. on your resume in relation to the job posting.</div>
            </div>
        </div>
    </div>
}

const CalculateScore = () => {
    const [openIndex, setOpenIndex] = useState(0);
    const videoRefs = useRef([]);

    const toggleAnswer = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    useEffect(() => {
        if (openIndex !== null && videoRefs.current[openIndex]) {
            videoRefs.current[openIndex].play();
        }
    }, [openIndex]);
    useEffect(() => {
        if (videoRefs.current[0]) {
            videoRefs.current[0].play();
        }
    }, []);
    const handleVideoEnd = () => {
        setOpenIndex((prevIndex) => (prevIndex + 1) % calculateScoreSteps.length);
    };
    return (
        <div className={styles.calculateScoreContainer}>
            <div className={styles.heading}>How do we calculate your resume score?</div>
            <div className={styles.stepsContainer}>
                <div className={styles.left}>
                    {calculateScoreSteps.map((data, index) => (
                        openIndex === index && (
                            <video
                                key={index}
                                muted
                                playsInline
                                ref={(el) => (videoRefs.current[index] = el)}
                                onEnded={handleVideoEnd}
                                onPause={() => {
                                    if (openIndex !== index) {
                                        videoRefs.current[index].pause();
                                    }
                                }}
                            >
                                <source src={data.video} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        )
                    ))}
                </div>
                <div className={styles.right}>
                    {calculateScoreSteps.map((data, index) => (
                        <>
                            <div onClick={() => toggleAnswer(index)} className={styles.question}>
                                <div className={[styles.point, openIndex === index ? styles.bold : ''].join(' ')}><span className={styles.step}>{data.step}</span>{data.point}</div>
                            </div>
                            <AnimatePresence>
                                {openIndex === index && (
                                    <motion.div
                                        key="answer"
                                        initial={{ height: 0 }}
                                        animate={{ height: 'auto' }}
                                        exit={{ height: 0 }}
                                        style={{ overflow: 'hidden' }}
                                    >
                                        <div className={styles.pointDesc}>{data.pointDesc}</div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                            <div className={styles.dashedLine}></div>
                        </>
                    ))}
                </div>
            </div>
        </div>
    );
};



const BuildResume = () => {
    const navigate = useNavigate();
    const resumeBuilderPage = () => {
        Utility.trackEvent('check-resume-score', 'BUTTON_CLIK', 'Resume Builder')
        window.location.href = BASEPATH + '/resume-build-home';
    }

    return <div className={styles.buildResumeContainer}>
        <div className={styles.buildResumeCotainerChild}>
            <div className={styles.left}>
                <div className={styles.heading}>
                    Build your ATS-friendly resume today!
                </div>
                <div className={styles.content}>
                    Unlock your career potential with our AI-powered Resume Builder. Designed to complement our Resume Scorer application, this tool allows you to create a standout resume. Join thousands who have transformed their resumes and advanced their careers with our comprehensive resume solutions. Whether you need to check your relevance score or want to improve your resume, our tools have got you covered.
                    Try paññã-resume builder today and get shortlisted for your next interview.
                </div>
                <div>
                    <Button id="build-resume-button-from-score" onClick={() => {
                        resumeBuilderPage();
                    }} text="Resume Builder" buttonStyle={styles.btn1}></Button>
                </div>
            </div>
            <div className={styles.right}>
                <img src={buildResumeFlowImage} className={styles.buildResumeFlowImage} />
            </div>
        </div>
    </div>
}







const mapStateToProps = reduxProps => ({
    reduxProps
});

const mapDispatchToProps = dispatch => ({
    dispatchRecentJds: recentJd => {
        dispatch(cacheRecentJDs(recentJd));
    },
    dispatchReportData: reportData => {
        dispatch(cacheReportData(reportData));
    },
    dispatchUpdateUserId: userId => {
        dispatch(updateUserId(userId));
    },
    dispatchUpdateUserName: userName => {
        dispatch(updateUserName(userName));
    },
    dispatchUpdateUserFile: userFiles => {
        dispatch(updateUserFile(userFiles));
    },
    dispatchGetResumeInHTML: userFiles => {
        dispatch(getResumeInHTML(userFiles));
    },
    dispatchUpdateHTMLLink: link => {
        dispatch(updateResumeHtmlLink(link));
    },
    dispatchUpdateResumeUrl: resumeUrl => {
        dispatch(updateResumeUrl(resumeUrl));
    },
    dispatchUpdateParsedResume: link => {
        dispatch(updateParsedResumeData(link));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(resumeScore);


